import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
  name: 'miliToTime'
})
export class MiliToTimePipe implements PipeTransform {

  transform(value: number) {
    if (value != null && value > 0) {
      let date = new Date(value);
      return date.getHours() + ":" + date.getMinutes();
    } else {
      return "0:0";
    }
  }

}
